export const EVENT_TYPE_LABELS = {
  SENSITIVE_FILE_ACCESS: 'Sensitive File Access',
  MALICIOUS_BOT_DETECTED: 'Malicious Bot',
  HIGH_RISK_BOT_BEHAVIOR: 'High-Risk Bot',
  MEDIUM_RISK_BOT_BEHAVIOR: 'Medium-Risk Bot',
  SCANNER_DETECTED: 'Scanner Detected',
  SUSPICIOUS_USER_AGENT: 'Suspicious User Agent',
  MALICIOUS_URL_PATTERN: 'Malicious URL',
  SUSPICIOUS_FILE_EXTENSION: 'Suspicious File',
  LEGITIMATE_BOT_ACCESS: 'Legitimate Bot',
  SUSPICIOUS_IP_MARKED: 'IP Marked Suspicious',
  LOGIN_ATTEMPT: 'Login Attempt',
  LOGIN_SUCCESS: 'Login Success',
  LOGIN_FAILURE: 'Login Failed',
  ADMIN_LOGIN: 'Admin Login',
  ADMIN_ACTION: 'Admin Action',
  UNAUTHORIZED_ACCESS: 'Unauthorized Access',
  RATE_LIMIT_EXCEEDED: 'Rate Limit',
  IP_BLOCKED: 'IP Blocked',
  XSS_ATTEMPT: 'XSS Attempt',
  SQL_INJECTION_ATTEMPT: 'SQL Injection',
  MALFORMED_REQUEST: 'Malformed Request',
};

export const PROTECTION_FEATURES = {
  file: ['.env file protection', 'Config file blocking', 'Source code protection', 'Database file security'],
  bot: ['Malicious bot detection', 'Scanner identification', 'Behavioral analysis', 'Risk scoring'],
  threat: ['Real-time IP scoring', 'Geographic analysis', 'Pattern recognition', 'Auto-blocking'],
};
